/**
 * Configuração do Questionário de Fornecedores — Automec (Reforma Tributária).
 *
 * A tela administrativa só é visível quando o projeto selecionado é o
 * AUTOMEC COMERCIAL DE VEICULOS LTDA. O questionário público em /automec
 * envia as respostas sempre para este projeto.
 */

// Projeto AUTOMEC COMERCIAL DE VEICULOS LTDA (índice ravena-projetos)
export const AUTOMEC_PROJECT_ID = "639903d1e193693c0d03e01f";

export const isAutomecProject = (project) =>
  !!project && project.id === AUTOMEC_PROJECT_ID;
